import { useTenantStore } from '@/stores/tenantStore'
import { $api, type InferResponse } from '../typedClient'

type EntityTypesResponse = InferResponse<'/crossroads/entity/types', 'get'>

interface EntityType {
  key: string
  label: string
  icon?: string
}

// Fallback types if endpoint fails
const fallbackEntityTypes: EntityType[] = [
  { key: 'company', label: 'Companies' },
  { key: 'product', label: 'Products' },
  { key: 'terminal', label: 'Terminals' },
  { key: 'site', label: 'Sites' },
  { key: 'tank', label: 'Tanks' },
]

// Transform API response to EntityType array
function transformEntityTypes(data: EntityTypesResponse): EntityType[] {
  if (!Array.isArray(data)) {
    return fallbackEntityTypes
  }

  return data.map((type) => {
    const capitalizedName =
      type.name.charAt(0).toUpperCase() + type.name.slice(1)
    const label =
      capitalizedName === 'Company' ? 'Companies' : `${capitalizedName}s`
    return {
      key: type.value,
      label: label,
    }
  })
}

export function useCrossroadsEntityTypes() {
  const { selectedTenant } = useTenantStore()

  return $api.useQuery(
    'get',
    '/crossroads/entity/types',
    {},
    {
      enabled: !!selectedTenant?.name,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      retry: false, // Don't retry on failure to prevent blocking
      select: transformEntityTypes,
    },
  )
}
